/**
 * Time tracking API calls.
 */

import client, { fetchAllPages } from './client';

export async function fetchTimeEntries(params = {}) {
  // All pages — TimeTrackingTab lists every entry on a job (build
  // jobs run weeks with many clock-ins; page-25 default truncates).
  // Same class of bug as fetchVendorQuotes (Kevin RFQ-tab report).
  return fetchAllPages('/time-entries/', params);
}

export async function createManualEntry(payload) {
  // Backend ViewSet.create() handles POST /time-entries/ for manual entries
  const { data } = await client.post('/time-entries/', payload);
  return data.data;
}

export async function editTimeEntry(entryId, payload) {
  const { data } = await client.patch(`/time-entries/${entryId}/`, payload);
  return data.data;
}

export async function deleteTimeEntry(entryId) {
  await client.delete(`/time-entries/${entryId}/`);
}

export async function fetchJobTimeSummary(jobId) {
  // Backend expects ?job=UUID (not job_id)
  const { data } = await client.get('/time-entries/job-summary/', { params: { job: jobId } });
  return data.data;
}

export async function fetchUsers() {
  const { data } = await client.get('/auth/users/');
  return data.data || data.results || [];
}
